import { useEffect, useMemo, useState } from "react";
import { IHeaderTable } from "types/global";

export const useMaintenanceItemListPdfHeader = () => {
  const [headers, setHeaders] = useState<IHeaderTable[]>([]);
  const columns = useMemo<IHeaderTable[]>(
    () => [
      {
        thaiLabel: "",
        width: 12,
      },
      {
        thaiLabel: "สินค้า",
        width: 122.2,
        align: "left",
      },
      {
        thaiLabel: "จำนวน",
        width: 50,
        align: "right",
      },
      {
        thaiLabel: "หน่วย",
        width: 50,
        align: "left",
      },
      {
        thaiLabel: "ราคา/หน่วย",
        width: 65,
        align: "right",
      },
      {
        thaiLabel: "ส่วนลด",
        width: 50,
        align: "right",
      },
      {
        thaiLabel: "ภาษี (%)",
        width: 45,
        align: "right",
      },
      {
        thaiLabel: "จำนวนเงิน",
        width: 65,
        align: "right",
      },
      {
        thaiLabel: "WHT",
        width: 45,
        align: "right",
      },
      {
        thaiLabel: "หมายเหตุ",
        width: 65,
        align: "left",
      },
    ],
    []
  );
  useEffect(() => {
    setHeaders(columns);
  }, [columns]);

  return headers;
};
